var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container",style:({ height: _vm.progressHeight + 'px' })},[_c('div',{ref:"progressBar",staticClass:"progress-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }